import { getTemplatesMetaTranslations } from "./modules/templatesMeta";
import { getOperationsTranslations } from "./modules/operations";
import { getMarketingTranslations } from "./modules/marketing";
import { getAutomationTranslations } from "./modules/automation";
import { getAnalyticsTranslations } from "./modules/analytics";
import { getPublicAccessTranslations } from "./modules/publicAccess";

const messages = {
  pt: {
    translations: {
      publicAccess: getPublicAccessTranslations("pt"),
      settingsSuite: {
        common: { updating: "ATUALIZANDO...", enabled: "✓ HABILITADO", disabled: "✕ DESABILITADO", saving: "SALVANDO...", save: "SALVAR", sending: "ENVIANDO...", sendTest: "ENVIAR TESTE", generating: "Gerando...", restoring: "Restaurando..." },
        page: { schedulesSuccess: "Horários atualizados com sucesso.", serviceCompletion: "Finalização do Atendimento", whitelabel: "Whitelabel" },
        branding: { section: "Tela de Login / Branding", title: "Personalize a experiência da sua marca", help: "Configure banner, logo, links e textos da tela de login sem alterar código e sem novo build.", smtp: "E-mail (SMTP)", port: "Porta", secure: "Seguro (SSL/TLS)", secureHelp: 'Use "true" para conexão segura e "false" para STARTTLS/normal.', appPassword: "Senha de aplicativo", sender: "Remetente (FROM)", senderExample: "Exemplo: Sua empresa <suporte@gmail.com>", testEmail: "E-mail para teste", testEmailHelp: "Se ficar vazio, será usado o e-mail informado acima.", whatsappLogin: "Exibir botão do WhatsApp na tela de login", bannerMode: "Modo do banner", imageUrl: "URL da imagem", internalUpload: "Upload / imagem interna", whatsappNumber: "Número do WhatsApp no login", loginLogo: "Logo da tela de login", logoUrl: "URL da logo da tela de login", logoUpload: "Upload da logo", sendLogo: "Enviar logo", removeUpload: "Remover upload", logoPriority: "Quando houver upload, ele terá prioridade sobre a URL da logo.", logoPreview: "Pré-visualização da logo", noLogo: "Nenhuma logo configurada", loginBanner: "Banner da tela de login", bannerUrl: "URL da imagem do banner", bannerUpload: "Upload do banner", sendBanner: "Enviar banner", bannerInternalHelp: "Quando o modo estiver em upload/imagem interna, o sistema usará este arquivo.", bannerPreview: "Pré-visualização do banner", noBanner: "Nenhum banner configurado", bannerTitle: "Título do banner", bannerSubtitle: "Subtítulo do banner" },
        meta: { section: "Integração Meta / Facebook / Instagram", title: "Configure a conexão da Meta diretamente no sistema", help: "Estes dados serão usados na tela de conexões para login com Facebook e Instagram, sem depender do .env e sem gerar um novo build.", appIdHelp: "Informe o App ID do seu aplicativo na Meta", appSecretHelp: "Informe o App Secret do seu aplicativo na Meta", embeddedSignupConfigId: "ID da configuração do Cadastro Incorporado (opcional)", embeddedSignupConfigIdHelp: "Necessário somente para usar o botão Conectar com a Coexistência.", sdkVersion: "Versão do SDK da Meta", permission: "Exigir permissão business_management" },
        options: { general: "Configurações gerais", currency: "Moeda da empresa", currencyHelp: "Usada nos valores de vendas, Kanban, relatórios e financeiro.", currencyUpdated: "Moeda atualizada com sucesso!", supportNumber: "Número de suporte", supportHelp: "Número com código do país, usado no botão Chamar Suporte.", aiSection: "IA — Sugestão de respostas", enableSuggestions: "Ativar sugestões de respostas", openAiKey: "Chave da API OpenAI", aiModel: "Modelo da IA", analyzedMessages: "Quantidade de mensagens analisadas", aiPrompt: "Prompt da IA", scheduleBot: "Agendamento e bot", companyRegistration: "Cadastro de empresas", requireDocument: "Exigir CPF/CNPJ no cadastro", push: "Notificações push", pushEnabled: "Push ativado", pushHelp: "Ative para receber notificações push neste navegador quando houver novas mensagens.", copyPrefix: "Configuração do prefixo para cópia de contato", efi: "Configuração Pix Efí (GerenciaNet)", sendCertificate: "Enviar certificado .P12 Efí", noCertificate: "Nenhum certificado enviado", certificatePassword: "Senha do certificado Efí" },
        backup: { sqlSuccess: "Backup SQL baixado com sucesso!", sqlError: "Erro ao gerar backup SQL.", jsonSuccess: "Backup JSON baixado com sucesso!", jsonError: "Erro ao gerar backup JSON.", sqlOnly: "Apenas arquivos .sql são aceitos para restauração.", confirm: "ATENÇÃO: a restauração substituirá os dados atuais do banco. Tem certeza de que deseja continuar? Recomendamos fazer um backup antes.", restoreSuccess: "Banco restaurado com sucesso! Recarregue a página.", restoreError: "Erro ao restaurar o banco de dados.", title: "Backup do banco de dados", description: "Baixe uma cópia completa do banco de dados no formato desejado.", sql: "Backup SQL (.sql)", json: "Backup JSON (.json)", tip: "O backup SQL é ideal para restauração completa. O backup JSON é útil para análise e migração de dados.", restoreTitle: "Restaurar banco de dados", danger: "Zona de perigo:", dangerHelp: "A restauração substituirá todos os dados atuais do banco. Tenha um backup atualizado antes de continuar.", upload: "Enviar arquivo .sql para restaurar", companyTitle: "Backup individual por empresa", companyDescription: "Exporte somente os dados da empresa selecionada, incluindo seus vínculos relacionais.", selectCompany: "Selecionar empresa", companySQL: "Empresa em SQL", companyJSON: "Empresa em JSON", companySuccess: "Backup da empresa baixado com sucesso!", companyError: "Erro ao gerar o backup da empresa.", companyListError: "Erro ao carregar as empresas.", selectCompanyError: "Selecione uma empresa." }
        ,completion: { title: "Finalização de atendimento", saleValue: "Informar valor da venda ao finalizar atendimento", saleValueHelp: "Quando habilitado, o campo de valor da venda aparecerá no modal de finalização.", reasons: "Motivos de finalização", addReason: "Adicionar motivo", noReasons: "Nenhum motivo cadastrado. Clique em Adicionar motivo para começar.", reasonName: "Nome do motivo", description: "Descrição (opcional)", nameRequired: "O nome do motivo é obrigatório.", updated: "Motivo atualizado com sucesso!", created: "Motivo criado com sucesso!", deleted: "Motivo excluído com sucesso!", configUpdated: "Configuração atualizada com sucesso!", configError: "Erro ao atualizar a configuração." }
        ,certificate: { noPermission: "Sem permissão para acessar!", p12Only: "Use somente arquivos no formato .p12!", chooseFile: "Escolha um arquivo!", chooseDestination: "Escolha um destino!", sent: "Arquivo enviado com sucesso!", title: "Certificado Efí — API Pix (.p12)", chooseOption: "Escolha uma opção:", option: "Certificado Efí .p12 da API Pix", send: "ENVIAR CERTIFICADO" }
        ,paymentGuide: { title: "Integração com o Mercado Pago", intro: "Para integrar seu sistema ao Mercado Pago, siga estas etapas:", account: "Crie uma conta no Mercado Pago Developers.", application: "Crie uma aplicação no Mercado Pago Developers.", production: "Acesse Produção e Credenciais de produção.", copyKey: "Copie a credencial e cole-a no campo Access Token.", notifications: "No Mercado Pago, acesse Notificações e Webhooks.", webhook: "No modo Produção, informe a URL exibida e marque Pagamentos em Eventos." }
        ,aiHelp: { apiKeySaved: "Sua chave da OpenAI ficará salva no banco de dados.", modelExample: "Exemplo: gpt-4o-mini", recommendedRange: "Recomendado: de 10 a 20 mensagens", promptHelp: "Defina como a IA deve responder." }
      },
      connectionSuite: {
        common: { yes: "Sim", no: "Não", cancel: "Cancelar", close: "Fechar", save: "Salvar", confirm: "Confirmar", loading: "Carregando...", error: "Erro", status: "Status", details: "Detalhes", createdAt: "Criado em", updatedAt: "Atualizado em", requiredPhone: "Informe o número de telefone.", brazilFormat: "Para números brasileiros, use 55 + DDD + número.", pairingCodeMissing: "Código de pareamento não retornado pelo servidor.", digitsHelp: "dígitos — código do país + DDD + número", waitingCode: "Aguardando código...", enterCodeNow: "Insira o código no WhatsApp", codeExpiring: "Código expirando!", generateCode: "Gerar código", activationHistory: "Histórico da ativação da API Oficial", connection: "Conexão", stepType: "Tipo de conexão", stepMeta: "Conectar com a Meta", stepFinish: "Concluir", processing: "Processando...", waitingMeta: "Aguardando a Meta...", finishOnboarding: "Concluir onboarding" },
        list: {
          transferProgress: "Transferindo tickets", tickets: "tickets", transferWait: "Aguarde enquanto os tickets são transferidos...", beforeDelete: "Antes de excluir", beforeDeleteHelp: "Você já transferiu os tickets desta conexão para outra? Se não, recomendamos transferir antes de excluir.", notYet: "Ainda não",
          whatsappOfficial: "WhatsApp Oficial", diagnosticsTooltip: "Diagnóstico da conexão", logsTooltip: "Logs do onboarding", syncTemplatesTooltip: "Sincronizar templates", copyWebhookTooltip: "Copiar webhook",
          selectConnections: "Selecione as conexões de origem e destino.", differentConnections: "As conexões de origem e destino devem ser diferentes.", metaLoginCancelled: "O login da Meta não foi concluído.", metaAppIdMissing: "Configure o App ID da Meta nas configurações do sistema.", metaSettingsLoading: "Carregando configurações da Meta. Aguarde um momento.", metaStarting: "A integração da Meta ainda está iniciando. Tente novamente em 2 segundos.", metaSdkLoading: "O SDK da Meta ainda está carregando. Tente novamente em alguns segundos.", metaSdkUnavailable: "O SDK do Facebook não está disponível. Recarregue a página."
        },
        modal: {
          connectionNameRequired: "Informe o nome da conexão.", telegramCredentialsRequired: "Informe API ID, API Hash e telefone.", telegramCodeSent: "Código enviado pelo Telegram. Confira o aplicativo Telegram.", sendCodeFirst: "Envie o código primeiro.", telegramCodeRequired: "Informe o código recebido no Telegram.", twoFactorRequired: "A senha de autenticação em dois fatores é obrigatória. Informe-a e confirme novamente.", sessionDisconnected: "Sessão desconectada com sucesso. Aguarde alguns segundos e gere o QR Code novamente na mesma conexão.", saveChangesFirst: "Clique em salvar para registrar as alterações.",
          officialOnboarding: "Onboarding self-service da API Oficial", officialOnboardingHelp: "Conecte a API Oficial pela Meta com o Cadastro Incorporado e, quando elegível, use o fluxo de coexistência com o número já existente no WhatsApp Business.", onboardingStatus: "Status do onboarding", connectionHealth: "Saúde da conexão", signedWebhook: "Webhook assinado", displayedNumber: "Número exibido", verifiedName: "Nome verificado", lastError: "Último erro", connectMeta: "Conectar com a Meta",
          welcomeFlow: "Fluxo de boas-vindas", welcomeFlowHelp: "Este fluxo é disparado apenas para novos contatos: pessoas que não estão na sua lista de contatos e que enviaram uma mensagem.", defaultResponseFlow: "Fluxo de resposta padrão", defaultResponseFlowHelp: "A resposta padrão é enviada quando a mensagem não corresponde a uma palavra-chave. Atenção: ela será disparada se o atendimento já estiver fechado."
        },
        diagnostics: {
          sendText: "Enviar teste em texto", sendTemplate: "Enviar teste com template", noDetails: "Sem detalhes de diagnóstico.",
          title: "Diagnóstico da API Oficial", help: "Valida token, número, inscrição do aplicativo e webhook, além de permitir reconectar ou testar o envio.", reconnectSuccess: "Reconexão solicitada com sucesso.", testNumberRequired: "Informe o número para teste.", textSuccess: "Mensagem de teste em texto enviada com sucesso.", templateNameRequired: "Informe o nome do template.", templateSuccess: "Mensagem de teste com template enviada com sucesso.",
          tokenPresent: "Token presente", tokenValid: "Token válido", wabaPresent: "ID da WABA presente", phoneIdPresent: "ID do número de telefone presente", numberAccessible: "Número acessível", appSubscribed: "Aplicativo inscrito na WABA", finalStatus: "Status final", textTest: "Teste em texto", textTestHelp: "Use quando houver uma janela de 24 horas aberta com o contato.", testMessage: "Mensagem de teste", templateTest: "Teste com template", templateTestHelp: "Use fora da janela de 24 horas, com um template aprovado pela Meta.", templateName: "Nome do template", templateLanguage: "Idioma do template", templateParameters: "Parâmetros do template", parametersHelp: "Separe os parâmetros por vírgula, na mesma ordem do template.", update: "Atualizar diagnóstico", reconnect: "Reconectar"
        },
        embedded: {
          title: "Onboarding self-service da API Oficial", chooseType: "Escolha o tipo de conexão", newNumber: "Novo número / nova conexão na API Oficial", newNumberHelp: "Ideal para ativar um número novo diretamente pelo fluxo da Meta.", currentNumber: "Usar meu número atual do WhatsApp Business", currentNumberHelp: "Fluxo de coexistência para contas elegíveis no aplicativo WhatsApp Business.", connectionName: "Nome da conexão", finalTestNumber: "Número para o teste final", selectedMode: "Modo selecionado", continueHelp: "Ao continuar, o sistema abrirá o onboarding da Meta para autorizar, vincular o número e concluir a conexão.", capturedData: "Dados capturados do onboarding", returnedCode: "Código retornado pela Meta", nextStep: "Próxima etapa", nextStepHelp: "O backend trocará o código por um token, sincronizará os dados da WABA, assinará o webhook, validará a conexão e tentará enviar a mensagem de teste.", connectionId: "ID da conexão", diagnostic: "Diagnóstico", capturedSuccess: "Retorno da Meta capturado com sucesso.", incompleteData: "Os dados do Cadastro Incorporado estão incompletos.", completed: "Onboarding da API Oficial concluído com sucesso.", createdSuccess: "Conexão criada com sucesso", createdPending: "Conexão criada com pendências"
        },
        logs: { title: "Logs do onboarding oficial", empty: "Nenhum log encontrado para esta conexão.", error: "Erro", payload: "Dados" },
        pairing: { title: "Conectar via código de pareamento", enterNumber: "Informe o número do WhatsApp com", countryCode: "código do país + DDD", example: "Exemplo", whatsappNumber: "Número do WhatsApp", tooShort: "Número muito curto. Inclua o código do país + DDD.", tooLong: "Número muito longo.", connected: "Conectado!", connectedHelp: "WhatsApp pareado com sucesso. A janela será fechada automaticamente.", instructions: "No seu WhatsApp, acesse:", path: "Configurações → Dispositivos conectados → Conectar um dispositivo", tap: "Toque em", phoneLink: "Conectar com número de telefone", enterCode: "e insira o código exatamente como exibido (sem espaços):", waiting: "Aguardando você inserir o código no WhatsApp...", syncing: "Sincronizando sessão... Quase lá!", tryAgain: "Tentar novamente", success: "WhatsApp conectado com sucesso!", failed: "O pareamento falhou. Tente novamente.", alreadyConnected: "O WhatsApp já está conectado!", generated: "Código gerado! Digite-o no WhatsApp em até 60 segundos." }
      },
      finalTouches: {
        common: { remove: "Remover", online: "Online", offline: "Offline" },
        ai: {
          title: "Agente IA Comercial", newAgent: "Novo agente", newTitle: "Novo Agente IA Comercial", editTitle: "Editar Agente IA Comercial",
          pageHelp: "Configure agentes comerciais para responder leads automaticamente, qualificar oportunidades, aplicar tags, gerar resumo interno e transferir para atendimento humano.",
          modalHelp: "Configure o agente para qualificar leads, aplicar tags, gerar resumo interno e transferir para atendimento humano quando necessário.",
          onlyPending: "Somente aguardando", allConnections: "Todas", transferQueue: "Fila de transferência", validConfig: "Configuração válida",
          interactions: "Interações", empty: "Nenhuma configuração encontrada.", removeTitle: "Remover configuração?",
          removeNamed: "Remover configuração {{name}}?", removeHelp: "Esta ação não remove sessões já registradas, apenas a configuração do agente."
        },
        warmup: {
          title: "Aquecimento de Chips", subtitle: "Conexões isoladas para aquecimento, sem misturar com as conexões padrão do sistema.",
          unavailableTitle: "Aquecimento de Chips indisponível", unavailableHelp: "Seu plano atual não possui acesso a esta funcionalidade.",
          waitingQr: "Aguardando QR", minDelayError: "O atraso mínimo precisa ser maior que 1000 ms.", maxDelayError: "O atraso máximo precisa ser maior ou igual ao mínimo.", saved: "Configuração salva com sucesso!",
          statusTitle: "Status do aquecimento", cluster: "Cluster", running: "em execução", stopped: "parado", onlineConnections: "Conexões online", active: "Aquecimento ativo", paused: "Aquecimento pausado",
          configuration: "Configuração", minDelay: "Atraso mínimo (ms)", maxDelay: "Atraso máximo (ms)", messagesPerCycle: "Mensagens por ciclo", prompt: "Frases alternadas / prompt",
          promptHelp: "Coloque uma frase por linha. O sistema sorteará e alternará automaticamente.", saveConfig: "Salvar configuração", newConnection: "Nova conexão", group: "Grupo", createQr: "Criar conexão / gerar QR",
          connectionsTitle: "Conexões de aquecimento", noNumber: "Nenhum número informado", session: "Sessão", reconnect: "Gerar QR / Reconectar", empty: "Nenhuma conexão de aquecimento cadastrada.", scanQr: "Escaneie o QR Code"
        },
        financial: {
          subtitle: "Acompanhe suas faturas, vencimentos e pagamentos em um só lugar.", subscriptionStatus: "Situação da assinatura", active: "Ativa", expired: "Vencida", currentDueDate: "Vencimento atual",
          totalRegistered: "Total registrado", open: "Em aberto", awaitingPayment: "Aguardando pagamento", processing: "Processando", confirming: "Confirmação em andamento", paidPlural: "Pagas", alreadyConfirmed: "Já confirmadas",
          organizedTitle: "Área financeira organizada", organizedHelp: "Consulte as faturas, acompanhe vencimentos e realize pagamentos com mais clareza.", expiredTitle: "Sua assinatura está vencida", expiredHelp: "Regularize o pagamento para manter o sistema em pleno funcionamento.",
          processingTitle: "Pagamento em processamento", processingHelp: "Identificamos um pagamento recente da sua assinatura. Após a confirmação do provedor, a atualização pode levar em média de 5 a 10 minutos.", pendingHelp: "Se você já concluiu o pagamento, a confirmação pode levar de 5 a 10 minutos. Esta tela será atualizada automaticamente.",
          whatNow: "O que acontece agora?", autoUpdateHelp: "Assim que a confirmação for concluída, a tela será atualizada automaticamente. Você pode permanecer nesta página e acompanhar o status.", invoice: "Fatura", value: "Valor", waitingTime: "Tempo aguardando", minutes: "{{count}} minuto(s)", updateNow: "Atualizar agora", viewProcessing: "Ver pagamento em processamento", notPaidYet: "Ainda não paguei",
          success: "Pagamento confirmado com sucesso. A assinatura foi atualizada.", paymentConfirmed: "Pagamento confirmado", dueToday: "Vence hoje", daysLeft: "Faltam {{count}} dia(s)", daysOverdue: "Atrasado há {{count}} dia(s)", subscriptionInvoice: "Fatura de assinatura", pay: "PAGAR", paid: "PAGO", empty: "Nenhuma fatura encontrada", emptyHelp: "Assim que houver lançamentos financeiros, eles aparecerão aqui.",
          statuses: { open: "Em Aberto", processing: "Processando", overdue: "Vencido", paid: "Pago" }
        },
        checkout: {
          subscriptionPayment: "Pagamento da assinatura", subscriptionPaymentHelp: "Escolha a forma de pagamento e conclua sua renovação com segurança.", providerHelp: "Após concluir o pagamento, a confirmação pode levar alguns minutos para refletir no sistema. A atualização da assinatura será feita automaticamente assim que o retorno do provedor for confirmado.",
          data: "Dados", customize: "Personalizar", review: "Revisar", finishRenewal: "Finalize sua renovação", finishRenewalHelp: "Gere sua cobrança com segurança e acompanhe a confirmação do pagamento pelo sistema.", confirmedHelp: "Recebemos a confirmação do pagamento e a assinatura já foi atualizada.", processingHelp: "Após concluir o pagamento, a confirmação pode levar em média de 5 a 10 minutos. A atualização será feita automaticamente.", chargeCreated: "Cobrança gerada com sucesso! Após o pagamento, a confirmação pode levar de 5 a 10 minutos.",
          back: "VOLTAR", next: "PRÓXIMO", generatePayment: "GERAR PAGAMENTO", month: "mês", select: "SELECIONAR", subscriptionSummary: "Resumo da assinatura", planDetails: "Detalhes do plano", users: "Usuários", connections: "Conexões", queues: "Filas", billing: "Cobrança", monthly: "Mensal", paymentInformation: "Informações de pagamento", email: "E-mail", name: "Nome", taxId: "CPF/CNPJ", total: "Total", stepNotFound: "Etapa não encontrada", invoiceNumber: "Fatura #{{id}}", licenseRenewed: "Sua licença foi renovada até {{date}}!", copied: "Copiado", copyPix: "Copiar código QR PIX", pixHelp: "Para finalizar, realize o pagamento escaneando ou colando o código Pix acima, ou escolha pagar com cartão de crédito abaixo.", payCreditCard: "Pagar com Cartão de Crédito", payMercadoPago: "Pagar com MercadoPago", payAsaas: "Pagar com Asaas"
        }
      },
      adminOps: {
  "navigation": {
    "serverReport": "Relatório do Servidor",
    "aiSalesAgent": "Agente IA Comercial"
  },
  "server": {
    "restricted": "Acesso restrito",
    "restrictedHelp": "O Relatório do Servidor é exclusivo para o Super Admin.",
    "title": "Relatório do Servidor",
    "subtitle": "Painel premium de saúde do sistema: infraestrutura, serviços, módulos comerciais, API Oficial, Wavoip, Landing Pages, Flowbuilder, Follow-up, Aquecimento de Chips e integrações.",
    "loading": "Carregando informações do sistema...",
    "refresh": "Atualizar",
    "online": "Online",
    "available": "Disponível",
    "warning": "Atenção",
    "critical": "Crítico",
    "offline": "Offline",
    "unknown": "Verificar",
    "noDetails": "Sem detalhes adicionais",
    "memory": "Memória RAM",
    "disk": "Disco",
    "cores": "{{count}} núcleos",
    "usedOf": "{{used}} GB usados de {{total}} GB",
    "environment": "Ambiente",
    "product": "Produto",
    "module": "Módulo",
    "server": "Servidor",
    "system": "Sistema",
    "serverUptime": "Uptime servidor",
    "backendUptime": "Uptime backend",
    "updatedAt": "Atualizado em",
    "pm2Services": "Serviços PM2",
    "infrastructureTitle": "Infraestrutura",
        "infrastructure": {
          "database": "Banco de dados principal do sistema.",
          "redis": "Cache, filas, adaptador de socket e recursos em tempo real.",
          "nginx": "Proxy reverso e publicação HTTPS dos serviços.",
          "pm2": "Gerenciador dos processos Node.js."
        },
    "systemModules": "Módulos do sistema",
    "modulesHelp": "Recursos estratégicos presentes no sistema carro-chefe.",
    "overallHealthy": "Todos os principais indicadores estão operando normalmente.",
    "memoryDetail": "memória",
    "service": {
      "backend": {
        "name": "Backend do sistema",
        "description": "API principal, autenticação, tickets, mensagens e integrações."
      },
      "frontend": {
        "name": "Frontend do sistema",
        "description": "Interface web do painel administrativo e atendimento."
      },
      "official": {
        "name": "API Oficial",
        "description": "Serviço dedicado para WhatsApp Cloud API / Meta."
      },
      "transcription": {
        "name": "Transcrição",
        "description": "Serviço auxiliar para transcrição e processamento de áudio."
      }
    },
    "feature": {
      "followup": "Agendamentos, lembretes e continuidade comercial.",
      "official": "WhatsApp Oficial, templates, mídia e janela de atendimento.",
      "warmup": "Módulo para aquecimento e preparação de conexões.",
      "email": "Configurações, eventos e estrutura para envio de e-mails.",
      "wavoip": "Chamadas, histórico e telefonia integrada.",
      "landing": "Captação de leads por formulários, WordPress e Elementor.",
      "flowbuilder": "Fluxos, automações e campanhas visuais.",
      "asaas": "Consulta de cobranças e segunda via de boletos.",
      "radar": "Análise inteligente de conversas e sugestões comerciais.",
      "campaigns": "Disparos, listas, relatórios e configuração de campanhas.",
      "codeModule": "Módulo encontrado no código",
      "configured": "Configurado no ambiente"
    },
    "featureName": {
      "followup": "Follow-up",
      "official": "API Oficial",
      "warmup": "Aquecimento de Chips",
      "email": "E-mail Marketing",
      "wavoip": "Wavoip",
      "landing": "Landing Pages",
      "flowbuilder": "Flowbuilder",
      "asaas": "Asaas / Boletos",
      "radar": "Radar de Oportunidades",
      "campaigns": "Campanhas"
    }
  },
  "ai": {
    "title": "Agente IA Comercial",
    "newAgent": "Novo agente",
    "pageHelp": "Configure agentes comerciais para responder leads automaticamente, qualificar oportunidades, aplicar tags, gerar resumo interno e transferir para atendimento humano.",
    "newTitle": "Novo Agente IA Comercial",
    "editTitle": "Editar Agente IA Comercial",
    "modalHelp": "Configure o agente para qualificar leads, aplicar tags, gerar resumo interno e transferir para atendimento humano quando necessário.",
    "name": "Nome",
    "status": "Status",
    "connection": "Conexão",
    "queue": "Fila",
    "agent": "Atendente",
    "interactions": "Interações",
    "actions": "Ações",
    "active": "Ativo",
    "inactive": "Inativo",
    "onlyWaiting": "Só aguardando",
    "all": "Todas",
    "transferQueue": "Fila de transferência",
    "noQueue": "Sem fila",
    "notDefined": "Não definido",
    "model": "Modelo IA",
    "temperature": "Temperatura",
    "maxInteractions": "Máximo de interações",
    "welcomeMessage": "Mensagem inicial",
    "salesPrompt": "Prompt comercial",
    "promptHelp": "Deixe vazio para usar o prompt padrão do sistema.",
    "questions": "Perguntas de qualificação, uma por linha",
    "tags": "Tags automáticas, uma por linha",
    "transferHuman": "Transferir para humano",
    "createOpportunity": "Criar oportunidade",
    "validConfig": "Configuração válida",
    "cancel": "Cancelar",
    "save": "Salvar",
    "edit": "Editar",
    "remove": "Remover",
    "empty": "Nenhuma configuração encontrada.",
    "removeTitle": "Remover configuração?",
    "removeNamed": "Remover configuração {{name}}?",
    "removeHelp": "Esta ação não remove sessões já registradas, apenas a configuração do agente.",
    "updated": "Configuração atualizada com sucesso.",
    "created": "Configuração criada com sucesso.",
    "enabled": "Agente IA Comercial ativado.",
    "disabled": "Agente IA Comercial desativado.",
    "removed": "Configuração removida com sucesso."
  },
  "connections": {
    "transferTickets": "Transferir Tickets",
    "transferTitle": "Transferência de Tickets",
    "transferHelp": "Selecione a conexão de origem e a de destino. Todos os atendimentos ativos serão movidos.",
    "source": "Origem",
    "destination": "Destino",
    "confirmTransfer": "Sim, transferir",
    "metaSetup": "Configure a Meta no sistema",
    "officialMeta": "Coexistência",
    "connectingFacebook": "Conectando Facebook...",
    "loadingFacebook": "Carregando Facebook...",
    "connectingInstagram": "Conectando Instagram...",
    "loadingInstagram": "Carregando Instagram...",
    "receiveComments": "Receber comentários",
    "sent": "ENVIADAS",
    "received": "RECEBIDAS",
    "dailyLimit": "Limite diário",
    "messagesDay": "msg/dia",
    "status": {
      "CONNECTED": "CONECTADO",
      "DISCONNECTED": "DESCONECTADO",
      "OPENING": "CONECTANDO",
      "PENDING": "PENDENTE",
      "TIMEOUT": "TEMPO ESGOTADO",
      "PAIRING": "PAREANDO"
    },
    "pairingCode": "Conectado via Código de Pareamento",
    "qrCode": "Conectado via QR Code"
  },
  "modal": {
    "chatbot": "Chatbot",
    "defaultFlow": "Fluxo Padrão",
    "telegramConfig": "Configuração do Telegram",
    "personalProfile": "Perfil pessoal",
    "personalHelp": "usa API ID, API Hash e telefone. A conta recebe um código no app Telegram. Não usa BotFather, token nem webhook. Funciona como uma sessão conectada, parecida com WhatsApp Web. Acesse:",
    "botHelp": "crie um bot no @BotFather, copie o token e cole abaixo. O sistema registra o webhook automaticamente.",
    "telegramType": "Tipo de conexão Telegram",
    "generatedAtTelegram": "Gerado em my.telegram.org",
    "generatedWithApi": "Gerado junto com o API ID",
    "phoneCountry": "Telefone com DDI",
    "receivedCode": "Código recebido",
    "twoFactor": "Senha 2FA, se tiver",
    "sendCode": "Enviar código",
    "confirm": "Confirmar",
    "botToken": "Token do Bot Telegram",
    "botTokenHelp": "Cole aqui o token gerado no @BotFather. O webhook será configurado automaticamente.",
    "importHistory": "Importar histórico ao conectar",
    "importDays": "Dias para importar",
    "maxDays": "Máximo permitido: 30 dias",
    "sessionTitle": "Sessão do WhatsApp",
    "sessionHelp": "Use esta opção quando a conexão ficar travada em \"Conectando\" ou \"Opening\". Ela desconecta apenas a sessão atual desta mesma conexão para permitir a geração de um novo QR Code, sem criar outra conexão.",
    "sessionHistory": "O histórico permanece vinculado à conexão atual, desde que o backend apenas limpe a sessão/auth e não apague a conexão.",
    "disconnectSession": "Desconectar sessão"
  }
},
      templatesMeta: getTemplatesMetaTranslations("pt"),
      operations: getOperationsTranslations("pt"),
      taskCleanup: {
        cleanResolved: "Limpar tarefas resolvidas",
        tasks: "Tarefas",
        allResolved: "Todas as resolvidas",
        allCompleted: "Todas as concluídas",
        allRejected: "Todas as recusadas",
        delete: "Excluir",
        deleting: "Excluindo...",
        confirmAll: "todas as tarefas concluídas e recusadas",
        confirmCompleted: "todas as tarefas concluídas",
        confirmRejected: "todas as tarefas recusadas",
        confirmQuestion: "Deseja realmente excluir {{items}}?",
        permanentWarning: "Esta ação é permanente e não poderá ser desfeita.",
        noneFound: "Nenhuma tarefa encontrada nessa categoria.",
        oneDeleted: "1 tarefa excluída com sucesso.",
        manyDeleted: "{{count}} tarefas excluídas com sucesso.",
        deleteError: "Não foi possível excluir as tarefas resolvidas.",
        team: "Equipe",
        pending: "Pendentes",
        today: "Hoje",
        overdue: "Atrasadas",
        withoutDeadline: "Sem prazo",
      },
      marketing: getMarketingTranslations("pt"),
      automation: getAutomationTranslations("pt"),
      analytics: getAnalyticsTranslations("pt"),
      i18nFix: {
        flowExportZip: "Exportar (.zip)",
        flowOpen: "Abrir fluxo",
        flowEdit: "Editar fluxo",
        flowDelete: "Excluir fluxo",
        flowDeleted: "Fluxo excluído com sucesso",
        flowDuplicated: "Fluxo duplicado com sucesso",
        flowDeleteNamed: 'Excluir fluxo "{{name}}"?',
        kanbanStage: "Etapa Kanban", selectKanbanStage: "Selecione uma Etapa Kanban",
        contactImportExport: "Exportar / Importar contatos", kanban: "Kanban",
        queueDeleted: "Fila excluída com sucesso!", selectRotationType: "Selecione o tipo de rodízio",
        deleteNestedOptions: "Tem certeza? Todas as opções internas também serão excluídas",
        facebookConnectionSuccess: "Facebook conectado com sucesso!", contactListSaved: "Lista de contatos salva com sucesso!",
        createdAt: "Criado em", updatedAt: "Atualizado em", to: "Até", getUsersError: "Erro ao carregar usuários",
        loading: "Carregando...", messageSaved: "Mensagem salva com sucesso!", addMessage: "Adicionar mensagem", editMessage: "Editar mensagem",
        integrationDeleted: "Integração excluída com sucesso!", category: "Categoria", language: "Idioma", metaId: "ID da Meta", status: "Status",
        quickMessageDeleted: "Resposta rápida excluída com sucesso!", scheduleDeleteTitle: "Excluir agendamento",
        scheduleDeleteMessage: "Tem certeza que deseja excluir este agendamento?", scheduleDeleted: "Agendamento excluído com sucesso!",
        invalidPhoneFormat: "Formato de telefone inválido", integrationTriggered: "Integração acionada com sucesso!", keyword: "Palavra-chave",
        connectionTitle: "Conexão", webhookSaved: "Webhook salvo com sucesso!", addWebhook: "Adicionar webhook",
        editWebhook: "Editar webhook", webhookUpdated: "Webhook atualizado com sucesso!",
      },
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          disabled:
            "Cadastro de usuários está desabilitado no momento. Por favor, tente novamente mais tarde.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          company: "Nome da Organização",
          phone: "Whatsapp (DDD + NÚMERO)",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      ticketInfo: {
        copyPhone: "Copiar telefone",
        quickMessages: "Respostas rápidas",
        phonecopied: "Telefone copiado para área de transferência!",
        noPhone: "Nenhum telefone disponível para copiar",
        copyError: "Erro ao copiar telefone",
      },
      login: {
        title: "Login",
        welcome: "Bem-vindo de volta",
        loginInstruction: "Entre com seus dados para acessar sua conta",
        form: {
          email: "Email",
          password: "Senha",
          button: "Acessar",
        },
        buttons: {
          submit: "Login",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      companies: {
        title: "Cadastrar Empresa",
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        dueDate: {
          expiration: "Sua assinatura expira em",
          days: "dias!",
          day: "dia!",
          expirationToday: "Sua assinatura expira hoje!",
        },
        token: "Token",
      },
      dashboard: {
        filters: "Filtros",
        filter: "FILTRAR ",
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes",
        },
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
        },
        cards: {
          inAttendance: "Em Atendimento",
          waiting: "Aguardando",
          activeAttendants: "Atendentes Ativos",
          finalized: "Finalizados",
          newContacts: "Novos Contatos",
          totalReceivedMessages: "Mensagens Recebidas",
          totalSentMessages: "Mensagens Enviadas",
          averageServiceTime: "T.M. de Atendimento",
          averageWaitingTime: "T.M. de Espera",
          status: "Status (Atual)",
          activeTickets: "Tickets Ativos",
          passiveTickets: "Tickets Passivos",
          groups: "Grupos",
        },
        users: {
          name: "Nome",
          numberAppointments: "Quantidade de Atendimentos",
          statusNow: "Atual",
          totalCallsUser: "Total de atendimentos por usuario",
          totalAttendances: "Total de atendimentos",
        },
        date: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
        },
        licence: {
          available: "Disponível até",
        },
        assessments: {
          totalCalls: "Total de Atendimentos",
          callsWaitRating: "Atendimentos aguardando avaliação",
          callsWithoutRating: "Atendimentos sem avaliação",
          ratedCalls: "Atendimentos avaliados",
          evaluationIndex: "Índice de avaliação",
          score: "Pontuação",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores",
        },
      },
      reports: {
        title: "Relatório de Pesquisas Realizadas",

        operator: "Operador",
        period: "Período",
        until: "Até",
        date: "Data",
        reportTitle: "Relatórios",
        calls: "Atendimentos",
        search: "Pesquisas",
        durationCalls: "Duracão dos atendimentos",
        grupoSessions: "Atendimentos em grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          errorToast: "Erro ao gerar o relatório",
          back: "Voltar",
          groupServiceReport: "Relatório de Atendimento em Grupos",
          loading: "Carregando...",
          contact: "Contato",
          dateOpen: "Data abertura",
          dateLastUpdated: "Data Última Atualização",
          agent: "Quem atendeu",
          agentClosed: "Quem fechou",
          waitingAssistance: "Aguardando atendimento",
          process: "Em atendimento",
        },
        researchReports: {
          response: "resposta",
          active: "(Ativa)",
          inactive: "(Inativa)",
          quantity: "Quantidade",
          percentage: "porcentagem",
          title: "Relatório de Pesquisas Realizadas",
          activeSearch: "Pesquisa ativa",
          inactiveSearch: "Pesquisa inativa",
        },
        ticketDurationDetail: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Duração do Atendimento",
          startService: "Início do atendimento",
          lastUpdated: "Última atualização",
          lastAgent: "Último atendente",
          durationFinished: "Duração após finalizado",
        },
        ticketDuration: {
          title: "Relatório de Duração dos Atendimento",
          contact: "Contato",
          open: "Abertos",
          pending: "Pendentes",
          finished: "Finalizados",
          durationFinished: "Duração dos finalizados",
          durationAfterFinished: "Duração após finalizado",
          actions: "Ações",
        },
        ticketReports: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Atendimento",
        },
        exportExcel: {
          title: "Relatórios de Atendimentos",
          startDate: "Data inicial",
          endDate: "Data final",
          notInformed: "Não informado",
          columns: {
            id: "ID",
            connection: "Conexão",
            contact: "Contato",
            user: "Usuário",
            queue: "Fila",
            status: "Status",
            lastMessage: "Última Mensagem",
            openDate: "Data Abertura",
            openTime: "Hora Abertura",
            closeDate: "Data Fechamento",
            closeTime: "Hora Fechamento",
            supportTime: "Tempo de Atendimento",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relação de Atendimentos Realizados",
          exportTitle: "Relação de Atendimentos em Grupos Realizados",
        },
      },
      todo: {
        newTask: "Nova Tarefa",
        add: "Adicionar",
        task: "Tarefas",
      },
      contactImportWpModal: {
        title: "Exportar Contatos para o Excel",
        buttons: {
          downloadModel: "Download modelo do excel para importação",
          closed: "Fechar",
          import: "Selecione o arquivo do excel para importar Contatos",
        },
      },
      connections: {
        title: "Conexões",
        waitConnection: "Aguarde... Suas conexões serão reiniciadas!",
        newConnection: "Nova Conexão",
        restartConnections: "Reiniciar Conexões",
        callSupport: "Chamar Suporte",
        newConnection: "Nova Conexão",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecte seus canais de atendimento para receber mensagens e iniciar conversas com seus clientes.",
        client: "Cliente",
        connectedConnections: " Conexões conectadas ",
        disconnectedConnections: "Conexões desconectadas ",
        totalConnections: " Total de Conexões",
        total: "Total",
        connections: "Conexões de:",

        toasts: {
          deleted: "Conexão excluída com sucesso!",
          closedimported:
            "Estamos fechando os tickets importados, por favor aguarde uns instantes",
        },
        confirmationModal: {
          closedImportedTitle: "Fechar tickets importados",
          closedImportedMessage:
            "Se você confirmar todos os tickets importados serão fechados",
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar Conexão",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          closedImported: "Fechar todos os tickets Importados",
          preparing: "Preparando mensagens para importação",
          importing: "Importando Mensagens do WhatsApp",
          newQr: "Novo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Data da mensagem",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
          number: "Número do Whatsapp",
          color: "Cor",
          receiveComments: "Receber Comentários",
        },
        receiveComments: {
          enabled: "Recebimento de comentários habilitado",
          disabled: "Recebimento de comentários desabilitado",
          tooltip: {
            enabled: "Comentários estão sendo recebidos. Clique para desabilitar.",
            disabled: "Comentários não estão sendo recebidos. Clique para habilitar.",
          },
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimento Existente",
        },
        form: {
          message: "Este contato já está em atendimento:",
          user: "Atendente",
          queue: "Fila",
          messageWait:
            "Este contato já está aguardando atendimento. Veja na aba Aguardando!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket criado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: " iniciou o atendimento.",
          access: "acessou o ticket.",
          transfered: "transferiu o ticket.",
          receivedTransfer: "recebeu o ticket transferido.",
          pending: "devolveu a fila.",
          closed: "fechou o ticket",
          reopen: "reabriu o ticket",
          redirect: "- redirecionado",
          clientClosed: "Cliente fechou o ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar Conexão",
          edit: "Editar Conexão",
        },
        tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "NPS",
          integrations: "Integrações",
          schedules: "Horário de expediente",
        },
        form: {
          importOldMessagesEnable: "Importar mensagens do aparelho",
          importOldMessages: "Data de inicio da importação",
          importRecentMessages: "Data de termino da importação",
          importOldMessagesGroups: "Importar mensagens de grupo",
          closedTicketsPostImported: "Encerrar tickets após importação",
          name: "Nome",
          queueRedirection: "Redirecionamento de Fila",
          queueRedirectionDesc:
            "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
          default: "Padrão",
          group: "Permitir grupos",
          timeSendQueue: "Tempo em minutos para redirecionar para fila",
          importAlert:
            "ATENÇÃO: Ao salvar, sua conexão será encerrada, será necessário ler novamente o QR Code para importar as mensagens",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Criar novo ticket em x minutos",
          maxUseBotQueues: "Enviar bot x vezes",
          maxUseInactiveTime: "Enviar flow de inatividade x vezes",
          timeUseBotQueues: "Enviar bot em x minutos",
          timeToReturnQueue: "Tempo para retornar a fila em minutos",
          timeAwaitActiveFlow: "Tempo para aguardar ativação do fluxo",
          expiresTicket: "Encerrar chats abertos após x minutos",
          expiresTicketNPS:
            "Encerrar chats aguardando avaliação após x minutos",
          maxUseBotQueuesNPS:
            "Quantidade máxima de vezes que a avaliaçao vai ser enviada",
          closeLastMessageOptions1: "Do atendente/Cliente",
          closeLastMessageOptions2: "Do atendente",
          outOfHoursMessage: "Mensagem de fora de expediente",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          lgpdLinkPrivacy: "Link para política de privacidade",
          lgpdMessage: "Mensagem de saudaçao LGPD",
          lgpdDeletedMessages: "Ofuscar mensagem apagada pelo contato",
          lgpdSendMessage: "Sempre solicitar confirmação do contato",
          ratingMessage: "Mensagem de avaliaçao - Escala deve ser de 0 a 10",
          token: "Token para integração externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensagem de inatividade",
          timeInactiveMessage:
            "Tempo em minutos para envio do aviso de inatividade",
          flowInactiveTime:
            "Tempo em minutos para envio do flow de inatividade",
          whenExpiresTicket:
            "Encerrar chats abertos quando última mensagem for",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          prompt: "Prompt",
          collectiveVacationEnd: "Data final",
          collectiveVacationStart: "Data inicial",
          collectiveVacationMessage: "Mensagem de férias coletivas",
          queueIdImportMessages: "Fila para importar as mensagens",
          isOficial: "Oficial",
          phone_number_id: "ID Número de telefone",
          waba_id: "Waba ID",
          send_token: "Token de envio",
          business_id: "ID do negócio",
          phone_number: "Número de telefone",
          triggerIntegrationOnClose: "Disparar Integração ao Encerrar Ticket",
          enableIntegration: "Habilitar Integração",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Desabilitado",
          minutes: "minutos",
        },
        success: "Conexão salvo com sucesso.",
        errorSendQueue:
          "Foi informado tempo para redirecionar fila, porém não foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos",
        errorExpiresNPS:
          "É obrigado informar um tempo para avaliação quando se utiliza o NPS.",
        errorRatingMessage:
          "É obrigado informar uma mensagem de avaliação quando se utiliza o NPS.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        emptyTitle: "Nenhum contato encontrado",
        emptyDescription: "Ajuste os filtros ou cadastre um novo contato para começar.",
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        conversationFlows: " Fluxos de Conversa",
        addFlow: "Adicionar Fluxo",
        editFlow: "Editar Fluxo ",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          exportContact: "Exportar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
          blockContact: "Tem certeza que deseja bloquear este contato?",
          unblockContact: "Tem certeza que deseja desbloquear este contato?",
          importMessage: "Deseja importar todos os contatos do telefone?",
          importChat: "Importar Conversas",
          wantImport: "Deseja importar todas as conversas do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contato",
        },
        loading: "Carregando...",
        loadMore: "Carregar Mais",
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          email: "Email",
          actions: "Ações",
          lastMessage: "Última Mensagem",
          wallet: "Carteira",
        },
        menu: {
          importYourPhone: "Importar do aparelho padrão",
          importToExcel: "Importar / Exportar do Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Encaminhada",
      },
      forwardMessageModal: {
        title: "Encaminhar mensagem",
        buttons: {
          ok: "Encaminhar",
        },
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensagens no Histórico",
          voiceKey: "Chave da API de Voz",
          voiceRegion: "Região de Voz",
        },
        success: "Prompt salvo com sucesso!",
        title: {
          add: "Adicionar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo Tokens Resposta",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        buttons: {
          add: "Adicionar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          chatBotContact: "Desabilitar chatbot",
          termsLGDP: "Termos LGPD aceito em:",
          whatsapp: "Conexão Origem: ",
          assignWallet: "Carteira de Cliente",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
        walletLinked: "Contato vinculado à sua carteira com sucesso!",
        walletError: "Usuário não possui filas associadas",
        saveFirst: "Contato deve ser salvo primeiro",
      },
      wallets: {
        title: "Carteiras de Contatos",
        searchPlaceholder: "Buscar contatos...",
        filterByUser: "Filtrar por Usuário",
        allUsers: "Todos os usuários",
        contact: "Contato",
        user: "Usuário",
        queue: "Fila",
        phone: "Telefone",
        email: "Email",
        actions: "Ações",
        editWallet: "Editar Carteira",
        selectUser: "Selecionar Usuário",
        selectQueue: "Selecionar Fila",
        selectUserAndQueue: "Selecione um usuário e uma fila",
        cancel: "Cancelar",
        save: "Salvar",
        confirmDeleteTitle: "Confirmar Exclusão",
        confirmDeleteMessage:
          "Tem certeza que deseja remover este contato da carteira?",
        notFound: "Carteira não encontrada.",
        deleteSuccess: "Contato removido da carteira com sucesso!",
        updateSuccess: "Carteira atualizada com sucesso!",
        wallet: "Carteira",
      },
      queueModal: {
        title: {
          queueData: "Dados da fila",
          text: "Horários de atendimento",
          add: "Adicionar fila",
          edit: "Editar fila",
          confirmationDelete:
            "Tem certeza? Todas as opções de integrações serão deletadas.",
        },
        form: {
          name: "Nome",
          color: "Cor",
          orderQueue: "Ordem da fila (Bot)",
          rotate: "Rodízio",
          timeRotate: "Tempo de Rodízio",
          typeRandomMode: "Tipo de rodízio",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          token: "Token",
          integrationId: "Integração",
          fileListId: "Lista de arquivos",
          closeTicket: "Fechar ticket",
          randomizeImmediate: "Randomizar Automaticamente (Imediato)",
          queueType: "Tipo de menu",
          message: "Mensagem de retorno",
          queue: "Fila para transferência",
          integration: "Integração",
          file: "Lista de arquivos",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opções",
          toolTipTitle: "Adicione opções para construir um chatbot",
          toolTip:
            "Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante",
          selectOption: "Selecione uma opção",
          text: "Texto",
          attendent: "Atendente",
          queue: "Fila",
          integration: "Integração",
          file: "Arquivo",
          toolTipMessageTitle:
            "A mensagem é obrigatória para seguir ao próximo nível",
          toolTipMessageContent:
            "A mensagem é obrigatória para seguir ao próximo nível",
          selectUser: "Selecione um Usuário",
          selectQueue: "Selecione uma Fila",
          selectIntegration: "Selecione uma Integração",
          addOptions: "Adicionar opções",
        },
        serviceHours: {
          dayWeek: "Dia da semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
      },
      userModal: {
        warning:
          "Para fazer a importação das mensagens é necessário ler o qrCode novamente !!!",
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
          updateImage: "Atualizar imagem",
          removeImage: "Excluir imagem",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          farewellMessage: "Mensagem de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          whatsapp: "Conexão Padrão",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Desabilitado",
          allTicket: "Visualizar chamados sem fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Aberto",
          defaultMenuClosed: "Fechado",
          defaultMenu: "Menu padrão",
          defaultTheme: "Tema Padrão",
          defaultThemeDark: "Escuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversas de outras filas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Desabilitado",
          allUserChat: "Ver conversas de outros usuários",
          userClosePendingTicket: "Permitir fechar tickets pendentes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendentes",
          showReturnQueueButton: "Mostrar botão de devolver para fila",
          showTransferTicketButton: "Mostrar botão de transferir ticket",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Painel de Atendimentos",
          allowConnections: "Permitir ações nas conexões",
          showContacts: "Ver contatos",
          showCampaign: "Ver campanhas",
          showFlow: "Ver automações",
        },
        tabs: {
          general: "Geral",
          permissions: "Permissões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addImage: "Adicionar Imagem",
          editImage: "Editar Imagem",
        },
        success: "Usuário salvo com sucesso.",
      },
      companyModal: {
        title: {
          add: "Adicionar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nome",
          email: "Email",
          passwordDefault: "Senha",
          numberAttendants: "Usuários",
          numberConections: "Conexões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Empresa salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
          message: "Mensagem",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          assinar: "Enviar Assinatura",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addSchedule: "Adicionar agendamento",
        },
        success: "Agendamento salvo com sucesso.",
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
          addKanban: "Nova Lane",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nome",
          color: "Cor",
          timeLane: "Tempo em minutos para redirecionar para lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Mensagem de saudação da lane",
          mediaFiles: "Mídia",
          rollbackLaneId: "Voltar para Lane após retomar atendimento",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salva com sucesso.",
        successKanban: "Lane salva com sucesso.",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "VOCÊ DESEJA FECHAR TODOS OS TICKETS?",
        yes: "SIM",
        not: "NÃO",
        buttons: {
          newTicket: "Novo",
          resolveAll: "Resolver Todos",
          close: "Fechar",
          new: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        messageHidden: "Mensagem oculta",
        inbox: {
          closedAllTickets: "Fechar todos os tickets?",
          closedAll: "Fechar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃO",
          open: "Abertos",
          resolverd: "Resolvidos",
        },
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
          messageHidden: "Mensagem oculta",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimento e mensagens",
          filterConections: "Filtro por Conexão",
          filterConectionsOptions: {
            open: "Aberto",
            closed: "Fechado",
            pending: "Pendente",
          },
          filterUsers: "Filtro por Usuarios",
          filterContacts: "Filtro por Contatos",
          ticketsPerPage: "Tickets por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a Fila",
          scredule: "Agendamento",
          deleteTicket: "Deletar Ticket",
        },
        closedTicket: {
          closedMessage: "Fechar Ticket Com Mensagem de Despedida",
          closedNotMessage: "Fechar Ticket Sem Mensagem de Despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldWhatsapp: "Selecione um whatsapp",
        noOptions: "Nenhum usuário encontrado com esse nome",
        msgTransfer: "Observações - mensagem interna, não vai para o cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsList: {
        called: "Chamado",
        today: "Hoje",
        missedCall: "Chamada de voz/vídeo perdida às",
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        noQueue: "Sem Fila",
        buttons: {
          accept: "Aceitar",
          cancel: "Cancelar",
          start: "iniciar",
          closed: "Fechar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opções de Kanban",
        },
        acceptModal: {
          title: "Aceitar Chat",
          queue: "Selecionar setor",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contato",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          chatsTempoReal: "Painel",
          tickets: "Atendimentos",
          quickMessages: "Respostas rápidas",
          contacts: "Contatos",
          wallets: "Carteiras",
          queues: "Filas & Chatbot",
          tags: "Tags",
          administration: "Administração",
          companies: "Empresas",
          users: "Usuários",
          birthdaySettings: "Config. Aniversário",
          settings: "Configurações",
          files: "Lista de arquivos",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          queueIntegration: "Integrações",
          version: "Versão",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Gerenciar conexões",
          reports: "Relatórios",
          management: "Gerência",
          callHistorical: "Histórico de Chamadas",
          automations: "Automações",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
            message: "Olá",
            messageEnd: "seja bem-vindo a",
            active: "Ativo até",
            goodMorning: "Oi,",
            myName: "meu nome é",
            continuity: "e darei continuidade em seu atendimento.",
            virtualAssistant: "Assistente Virtual",
            token:
              "Token inválido, por favor entre em contato com o administrador da plataforma.",
          },
          message: {
            location: "Localização",
            contact: "Contato",
          },
          notRegister: "Nenhum registro",
          refresh: "Atualizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Português",
        es: "Español",
        en: "English",
        tr: "Türkçe",
        ar: "Árabe",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        extended: {
          documentationTitle: "Documentação para envio de mensagens", methodsTitle: "Métodos de Envio", new: "NOVO",
          mediaMessages: "Mensagens de Mídia", checkNumber: "Verificar Número", noTicket: "Envio Sem Ticket", imageUrl: "Imagem por URL", bulk: "Envio em Lote", listConnections: "Listar Conexões", interactiveButtons: "Mensagem com Botões", mixedButtons: "Botões Mistos (quick_reply + URL)",
          tokenInstruction: "Antes de enviar mensagens, cadastre o token vinculado à conexão que fará o envio. Acesse Conexões, edite a conexão e informe o token.", numberInstruction: "O número deve conter somente Código do País + DDD + Número, sem máscara ou caracteres especiais (ex.: 5511999998888).", headerInstruction: "Todos os endpoints exigem o header:",
          testSend: "Teste de envio", textTitle: "Mensagens de Texto", textDescription: "Envio de mensagem de texto com registro de ticket.", mediaDescription: "Envio de arquivos (imagem, áudio, vídeo ou documento).", checkTitle: "Verificar Número no WhatsApp", checkDescription: "Verifica se um número possui WhatsApp ativo antes do envio.", noTicketTitle: "Envio Sem Ticket (Disparo Rápido)", noTicketDescription: "Envia uma mensagem diretamente, sem criar ou registrar ticket. Ideal para notificações rápidas.", imageTitle: "Envio de Imagem por URL", imageDescription: "Envia uma imagem por URL pública, sem precisar carregar um arquivo.", bulkTitle: "Envio em Lote (Bulk)", bulkDescription: "Envia mensagens para vários números em uma requisição. Limite: 100 mensagens por lote.", connectionsTitle: "Listar Conexões Disponíveis", connectionsDescription: "Retorna as conexões WhatsApp ativas da empresa e seus respectivos IDs.", buttonsTitle: "Mensagem com Botões Interativos", buttonsDescription: "Envia uma mensagem interativa com até 3 botões. Também aceita listas, URLs e PIX.", mixedTitle: "Botões Mistos (quick_reply + URL + copy + call)", mixedDescription: "Envia uma mensagem com diferentes tipos de botão. Limite de 5 botões.",
          bodyJson: "Body JSON:", response: "Resposta:", registeredToken: "Token cadastrado *", number: "Número *", message: "Mensagem *", userId: "ID do usuário/atendente", queueId: "ID da fila", caption: "Legenda (opcional)", imageAddress: "URL da imagem *", messagesJson: "JSON das mensagens *", buttonsJson: "JSON dos botões *", mixedButtonsJson: "JSON dos botões mistos *", footer: "Rodapé (footer)", send: "Enviar", verify: "Verificar", sendBatch: "Enviar lote", sendButtons: "Enviar botões", sendMixed: "Enviar mistos", list: "Listar conexões", invalidJson: "JSON inválido.", success: "Operação realizada com sucesso.",
          accessDenied: "Esta empresa não possui permissão para acessar esta página.", headersJson: "Headers: Authorization Bearer (token) e Content-Type (application/json)", headersForm: "Headers: Authorization Bearer e Content-Type (multipart/form-data)", formData: "FormData:", optionalCaption: "Legenda (opcional)", userIdHelp: "ID do usuário ou vazio", queueIdHelp: "ID da fila ou vazio", file: "arquivo", delayHelp: "delay: intervalo em ms entre envios (padrão: 2000)", bodyButtons: "Body JSON (Botões):", bodyList: "Body JSON (Lista):", queueClick: "queueId: direciona o ticket para a fila ao clicar", userClick: "userId: atribui o ticket a um atendente específico", maxButtons: "Máx. 3 botões (5 no mixed)", quickReplyHelp: "quick_reply: botão de resposta rápida (com id)", urlHelp: "cta_url: abre um link externo", copyHelp: "cta_copy: copia texto (ex.: PIX)", callHelp: "cta_call: inicia ligação", maxMixed: "Máx. 5 botões"
        },
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
          userId: "ID do usuário/atendente",
          queueId: "ID da Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        API: {
          title: "Documentação para envio de mensagens",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensagens de Texto",
            messagesMidia: "Mensagens de Media",
          },
          instructions: {
            title: "Instruções",
            comments: "Observações Importantes",
            comments1:
              "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. <br />Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
            comments2:
              "O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:",
            codeCountry: "Código do País",
            code: "DDD",
            number: "Número",
          },
          text: {
            title: "1. Mensagens de Texto",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
        },
      },
      birthday: {
        defaultUserMessage: "🎉 Parabéns, {nome}! Hoje é seu dia especial! Desejamos muito sucesso e felicidade!", defaultContactMessage: "🎉 Parabéns, {nome}! Hoje é seu aniversário! Desejamos muito sucesso, saúde e felicidade! ✨",
        title: "Configurações de Aniversário", loading: "Carregando configurações...", users: "Aniversários de Usuários", contacts: "Aniversários de Contatos", general: "Configurações Gerais", selectConnection: "Selecione uma conexão", saving: "Salvando...",
        enableUsers: "Habilitar notificações de aniversário de usuários", enableUsersHelp: "Exibe o modal de parabéns e cria um informativo automático.", createUserNotice: "Criar informativo automático para aniversários de usuários", createUserNoticeHelp: "Cria um informativo visível para todos os usuários da empresa.", userMessage: "Mensagem de aniversário para usuários", userMessageHelp: "Use {nome} para incluir o nome do usuário.",
        enableContacts: "Habilitar envio automático de mensagens para contatos aniversariantes", enableContactsHelp: "Envia automaticamente uma mensagem de parabéns pelo WhatsApp.", contactMessage: "Mensagem de aniversário para contatos", contactMessageHelp: "Use {nome} para o nome e {idade} para a idade.", preview: "Pré-visualização:", test: "Testar mensagem", sendTime: "Horário de envio das mensagens", sendTimeHelp: "Horário em que as mensagens automáticas serão enviadas.", connection: "Conexão WhatsApp para envio", connectionHelp: "Conexão usada para enviar as mensagens de aniversário.", internalNotice: "Criar informativo interno para aniversários de usuários", internalNoticeHelp: "Cria um informativo interno quando um usuário faz aniversário.", variables: "Variáveis disponíveis nas mensagens:", personName: "Nome da pessoa", personAge: "Idade da pessoa (somente para contatos)", save: "Salvar configurações",
        loadError: "Erro ao carregar configurações de aniversário.", saveSuccess: "Configurações de aniversário salvas com sucesso! 🎉", saveError: "Erro ao salvar configurações.", promptContact: "Digite o ID de um contato para teste:", testSuccess: "Mensagem de teste enviada! 📱", testError: "Erro ao enviar mensagem de teste.", congratulations: "Parabéns!", specialDay: "Hoje é um dia especial!", loadingPeople: "Carregando aniversariantes...", systemUser: "Usuário do sistema", alreadySent: "Mensagem já enviada", sendCongratulations: "Enviar parabéns", sentTo: "Mensagem de parabéns enviada para {{name}}! 🎉", alreadySentToast: "A mensagem de aniversário já foi enviada hoje para este contato.", sendError: "Erro ao enviar mensagem de aniversário."
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
        messageHidden: "Mensagem oculta",
        newMessage: "Nova mensagem de",
      },
      triggerFlowModal: {
        title: "Disparar Fluxo",
        description:
          "Selecione um fluxo para executar neste ticket. O ticket será alterado para status 'chatbot' durante a execução.",
        selectFlow: "Escolha um fluxo",
        selectedFlow: "Fluxo selecionado",
        flowId: "ID do fluxo",
        noFlows: "Nenhum fluxo ativo encontrado",
        cancel: "Cancelar",
        trigger: "Disparar Fluxo",
        triggering: "Disparando...",
        success: "Fluxo disparado com sucesso!",
        error: "Erro ao disparar fluxo",
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        noAttachment: "Sem anexo",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        selectMessage: "Selecionar Resposta Rápida",
        hasMedia: "Com mídia",
        global: "Global",
        noResultsFound: "Nenhuma resposta rápida encontrada para sua busca",
        noQuickMessages: "Nenhuma resposta rápida disponível",
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          general: "Geral",
          visao: "Permitir visão",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },

      kanban: {
        title: "Kanban",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Painel",
          tags: "Lanes",
        },
      },

      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Listagem",
          listContacts: "Lista de contatos",
          settings: "Configurações",
        },
        settings: {
          randomInterval: "Intervalo Randômico de Disparo",
          noBreak: "Sem Intervalo",
          intervalGapAfter: "Intervalo maior após",
          undefined: "Não definido",
          messages: "mensagens",
          laggerTriggerRange: "Intervalo de disparo maior",
          addVar: "Adicionar variável",
          save: "Salvar",
          close: "Fechar",
          add: "Adicionar",
          shortcut: "Atalho",
          content: "Conteúdo",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          contactList: "Lista de Contatos",
          option: "Nenhuma",
          disabled: "Desabilitada",
          enabled: "Habilitada",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          help: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de Confirmação 1",
            confirmationMessage2: "Mensagem de Confirmação 2",
            confirmationMessage3: "Mensagem de Confirmação 3",
            confirmationMessage4: "Mensagem de Confirmação 4",
            confirmationMessage5: "Mensagem de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Tags",
            statusTicket: "Status do Ticket",
            openTicketStatus: "Aberto",
            pendingTicketStatus: "Pendente",
            closedTicketStatus: "Fechado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Desabilitado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
        },
      },
      campaignReport: {
        title: "Relatório de",
        inactive: "Inativa",
        scheduled: "Programada",
        process: "Em Andamento",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campanha",
        validContacts: "Contatos Válidos",
        confirmationsRequested: "Confirmações Solicitadas",
        confirmations: "Confirmações",
        deliver: "Entregues",
        connection: "Conexão",
        contactLists: "Lista de Contatos",
        schedule: "Agendamento",
        conclusion: "Conclusão",
        fetchError: "Erro ao buscar dados do relatório",
        backButton: "Voltar",
      },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        active: "Ativo",
        inactive: "Inativo",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
            high: "Alta",
            medium: "Média",
            low: "Baixa",
            active: "Ativo",
            inactive: "Inativo",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
      },
      queues: {
        title: "Filas & Chatbot",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          orderQueue: "Ordenação da fila (bot)",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar fila",
        },
        toasts: {
          success: "Fila salva com sucesso",
          deleted: "Fila exclu[ida com sucesso",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queue: {
        queueData: "Dados",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas somente leitura",
        withoutQueue: "Sem fila",
      },
      reports: {
        title: "Relatórios de Atendimentos",
        startDate: "Data Inicial",
        endDate: "Data final",
        table: {
          id: "Ticket",
          user: "Usuário",
          dateOpen: "Data Abertura",
          dateClose: "Data Fechamento",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Conexão",
          queue: "Fila",
          actions: "Ações",
          lastMessage: "Últ. Mensagem",
          contact: "Cliente",
          supportTime: "Tempo de Atendimento",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Apenas Avaliados",
        },
        searchPlaceholder: "Pesquisar...",
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas",
        },
      },
      users: {
        title: "Usuários",
        table: {
          status: "Status",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Ativo",
          name: "Nome",
          email: "Email",
          password: "Senha",
          phone: "Telefone",
          plan: "Plano",
          active: "Ativo",
          numberAttendants: "Atendentes",
          numberConections: "Conexões",
          value: "Valor",
          namePlan: "Nome Plano",
          numberQueues: "Filas",
          useCampaigns: "Campanhas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamento",
          createdAt: "Criada Em",
          dueDate: "Vencimento",
          lastLogin: "Ult. Login",
          folderSize: "Tamanho da pasta ",
          totalFiles: " Total de arquivos",
          lastUpdate: "Ultimo update",
          actions: "Ações",
          money: "R$",
          currency: "Moeda",
          brl: "BRL — Real brasileiro",
          cop: "COP — Peso colombiano",
          usd: "USD — Dólar americano",
          yes: "Sim",
          no: "Não",
          document: "CNPJ/CPF",
          recurrence: "Recorrência",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpar",
          delete: "Excluir",
          user: "Usuário",
          save: "Salvar",
          generateInvoice: "Gerar Fatura",
        },
        buttons: {
          add: "Adicionar empresa",
        },
        toasts: {
          deleted: "Empresa excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      plans: {
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "R$",
          currency: "Moeda",
          brl: "BRL — Real brasileiro",
          cop: "COP — Peso colombiano",
          usd: "USD — Dólar americano",
          public: "Público",
          trial: "Trial",
          trialDays: "Dias Trial",
        },
      },
      helps: {
        title: "Central de Ajuda",
        settings: {
          codeVideo: "Código do Video",
          description: "Descrição",
          clear: "Limpar",
          delete: "Excluir",
          save: "Salvar",
        },
      },
      schedules: {
        title: "Agendamentos",
        date: "Data",
        time: "Hora",
        event: "Evento",
        allDay: "Dia Todo",
        week: "Semana",
        work_week: "Agendamentos",
        day: "Dia",
        month: "Mês",
        previous: "Anterior",
        next: "Próximo",
        yesterday: "Ontem",
        tomorrow: "Amanhã",
        today: "Hoje",
        agenda: "Agenda",
        noEventsInRange: "Não há agendamentos no período.",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADICIONAR COLUNAS",
        search: "BUSCAR",
        seeTicket: "VER TICKET",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          id: "ID",
          name: "Nome",
          kanban: "Kanban",
          color: "Cor",
          tickets: "Registros Tags",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Tag",
        },
        toasts: {
          deleted: "Tag excluído com sucesso.",
        },
      },

      tagsKanban: {
        title: "Lanes",
        laneDefault: "Em aberto",
        backToKanban: "VOLTAR PARA O KANBAN",

        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Lane?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Tickets",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lane",
        },
        toasts: {
          deleted: "Lane excluída com sucesso.",
        },
      },

      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        tabs: {
          options: "Opções",
          plans: "Planos",
          helps: "Ajuda",
          companies: "Empresas",
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          tabs: {
            options: "Opções",
            schedules: "Horários",
            plans: "Planos",
            help: "Ajuda",
          },
          options: {
            disabled: "Desabilitado",
            enabled: "Habilitado",
            updating: "Atualizando...",
            open: "Aberto",
            pending: "Pendente",
            creationCompanyUser: "Criação de Company/Usuário",
            evaluations: "Avaliações",
            officeScheduling: "Agendamento de Expediente",
            queueManagement: "Gerenciamento por Fila",
            companyManagement: "Gerenciamento por Empresa",
            connectionManagement: "Gerenciamento por Conexão",
            sendGreetingAccepted: "Enviar saudação ao aceitar o ticket",
            sendMsgTransfTicket:
              "Enviar mensagem transferência de setor/atendente",
            checkMsgIsGroup: "Ignorar Mensagens de Grupos",
            chatBotType: "Tipo do Bot",
            userRandom: "Escolher atendente aleatório",
            buttons: "Botões",
            acceptCallWhatsapp: "Informar que não aceita ligação no whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues:
              "Enviar saudação quando houver somente 1 fila",
            sendQueuePosition: "Enviar mensagem com a posição da fila",
            sendFarewellWaitingTicket:
              "Enviar mensagem de despedida no Aguardando",
            acceptAudioMessageContact:
              "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamento LGPD",
            requiredTag: "Tag obrigatoria para fechar ticket",
            closeTicketOnTransfer:
              "Fechar ticket ao transferir para outra fila",
            transferredTicketStatus:
              "Status do ticket ao transferir com usuário",
            DirectTicketsToWallets:
              "Mover automaticamente cliente para carteira",
            showNotificationPending:
              "Mostrar notificação para tickets pendentes",
            copyContactPrefix: "Sigla para Cópia de Contatos",
            copyContactPrefixPlaceholder: "Ex: COPIA_"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensagem de posição na fila",
            AcceptCallWhatsappMessage:
              "Mensagem para informar que não aceita ligações",
            greetingAcceptedMessage: "Mensagem de Saudação ao aceitar ticket",
            transferMessage:
              "Mensagem de transferência - ${queue.name} = fila destino",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensagem de boas vindas(LGPD)",
            linkLGPD: "Link da política de privacidade",
            obfuscateMessageDelete: "Ofuscar mensagem apagada",
            alwaysConsent: "Sempre solicitar consentimento",
            obfuscatePhoneUser: "Ofuscar número telefone para usuários",
            enabled: "Habilitado",
            disabled: "Desabilitado",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          dialogRatingTitle:
            "Deseja deixar uma avaliação de atendimento para o cliente?",
          dialogClosingTitle: "Finalizando o atendimento com o cliente!",
          dialogRatingCancel: "Resolver COM Mensagem de Despedida",
          dialogRatingSuccess: "Resolver e Enviar Avaliação",
          dialogRatingWithoutFarewellMsg: "Resolver SEM Mensagem de Despedida",
          ratingTitle: "Escolha um menu de avaliação",
          notMessage: "Nenhuma mensagem selecionada",
          amount: "Valor de prospecção",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            rating: "Enviar Avaliação",
            enableIntegration: "Habilitar integração",
            disableIntegration: "Desabilitar integração",
            logTicket: "Logs do Ticket",
            requiredTag: "Você deve atribuir uma tag antes de fechar o ticket.",
            greetingAcceptedMessage:
              "Você deve configurar uma mensagem de saudação ao aceitar o ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderOpen:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        privateMessage: "Mensagem Privada",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Outras informações",
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          user: "Atendente",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
          ticket_id: "Nº do Chamado",
          queue: "Setor",
          connection: "Conexão",
          scheduledDate: "Data do Agendamento",
        },
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        resolveWithNoFarewell: "Finalizar sem despedida",
        acceptAudioMessage: "Aceitar áudios do contato?",
        appointmentsModal: {
          title: "Observações do Ticket",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket do contato",
          titleFrom: "do contato ",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Habilitar/Desabilitar Assinatura",
          privateMessage: "Habilitar/Desabilitar Mensagem Privada",
          meet: "Enviar link para videoconferencia",
          triggerFlow: "Disparar Fluxo",
        },
        type: {
          imageVideo: "Fotos e vídeos",
          cam: "Câmera",
          contact: "Contato",
          meet: "Vídeo chamada",
          template: "Template Meta",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        edit: "Editar",
        forward: "Encaminhar",
        toForward: "Encaminhar",
        talkTo: "Conversar Com",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Faturas",
          details: "Detalhes",
          users: "Usuários",
          connections: "Conexões",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Data Venc.",
          action: "Ação",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_OUT_OF_HOURS: "Fora do Horário de Expediente!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) e Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensagem"',
        fieldUserId: '"userId": ID do usuário ou ""',
        fieldQueueId: '"queueId": ID da Fila ou ""',
        fieldSendSignature: '"sendSignature": Assinar mensagem - true/false',
        fieldCloseTicket: '"closeTicket": Encerrar o ticket - true/false',
        singMessage: "Assinar mensagem - true/false",
        closeTicket: "Encerrar o ticket - true/false",
        testSend: "Teste de envio",
      },
      recurrenceSection: {
        title: "Recorrência",
        description:
          "Você pode escolher enviar a mensagem de forma recorrente e escolher o intervalo. Caso seja uma mensagem a ser enviada uma única vez, não altere nada nesta seção.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor do Intervalo",
        sendAsManyTimes: " Enviar quantas vezes",
        shipNormallyOnNonbusinessDays: " Enviar normalmente em dias não úteis",
        sendOneBusinessDayBefore: "Enviar um dia útil antes",
        sendOneBusinessDayLater: "Enviar um dia útil depois",
        options: {
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      servicePanel: {
        allowRealTime: "Painel de Atendimentos",
      },
      financial: {
        invoices: "Faturas",
        details: "Detalhes",
        users: "Usuários",
        connections: "Conexões",
        queues: "Filas",
        value: "Valor",
        expirationDate: "Data Venc.",
        status: "Status",
        action: "Ação",
      },
      statusFilter: {
        statusFilter: "Filtro por Status",
      },
      momentsUser: {
        services: "Atendimentos:",
        pending: "Pendentes",
        noqueue: "SEM FILA",
      },
      campaignsPhrase: {
        campaignsFlow: "Fluxo de Campanhas",
        campaigns: "Campanhas",
        name: "Nome",
        status: "Status",
        newCampaignWithFlowByPhrase: "Nova campanha com fluxo por frase",
        editCampaignWithFlowByPhrase: "Editar campanha com fluxo por frase",
        phraseTriggerName: "Nome do disparo por frase",
        chooseAStream: "Escolha um fluxo",
        whichPhraseTriggersTheFlow: " Qual frase dispara o fluxo?",
        selectAConnection: " Selecione uma Conexão",
        chooseAStream: " Escolha um fluxo",
        status: " Status",
        cancel: "CANCELAR",
        createCampaign: "CRIAR CAMPANHA ",
        saveCampaign: "Salvar Campanha",
      },
      whatsappModalRel: {
        form: {
          isOficial: "Relatório do Atendimento",
          ticketId: "ID do Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Atendente",
          date: "Data",
          lastMessage: "Última Mensagem",
          fullReport: "O relatório completo foi anexado acima",
          resolveAndTriggerIntegration: "Resolver e Disparar Integração",
          elementNotFoundForExport: "Elemento não encontrado para exportar.",
          reportFilename: "relatório_atendimento",
        },
      },
      chatList: {
        noMessages: "Nenhuma mensagem",
        admin: "Administrador",
        member: "Membro",
        searchChat: "Procurar chat...",
        createNewChat: "Criar novo chat",
        searchUser: "Procurar usuário...",
        noUserFound: "Nenhum usuário encontrado",
        noUserAvailable: "Nenhum usuário disponível",
        cancel: "Cancelar",
        details: "Detalhes",
        deleteChat: "Excluir Conversa",
        deleteChatConfirm: "Esta ação não pode ser revertida, confirmar?",
        detailsTitle: "Detalhes",
        edit: "Editar",
        delete: "Excluir",
        now: "agora",
        minutesAgo: "{{count}}m atrás",
        hoursAgo: "{{count}}h atrás",
      },
      chatMessages: {
        deleted: "Esta mensagem foi apagada",
        deletedAdmin: "Mensagem apagada - visível apenas para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        cancel: "Cancelar",
        deleteMessage: "Deletar Mensagem",
        deleteMessageConfirm: "Tem certeza que deseja deletar esta mensagem?",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        doubleClickToReply: "Clique duas vezes para responder",
        edited: "(editada)",
        forwarded: "(encaminhada)",
        typeMessage: "Digite uma mensagem...",
        send: "Enviar",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        replyingTo: "Respondendo a",
        clickToGoToOriginal: "Clique para ir até a mensagem original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Exclusão",
        confirm: "Confirmar",
        deleteMessage: "Tem certeza que deseja excluir esta mensagem?",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        forward: "Encaminhar",
        noChats: "Nenhum chat disponível",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Novo",
        messages: "Mensagens",
        search: "Buscar...",
        noChats: "Nenhum chat encontrado",
        noGroups: "Nenhum grupo encontrado",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        error: "Erro ao carregar dados",
        addGroupPhoto: "Adicionar Foto do Grupo",
        changeGroupPhoto: "Alterar Foto do Grupo",
        groupName: "Nome do Grupo",
        groupDescription: "Descrição do Grupo",
        save: "Salvar",
        cancel: "Cancelar",
        createGroup: "Criar Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Deletar Grupo",
        deleteGroupConfirm: "Tem certeza que deseja deletar este grupo?",
        edit: "Editar",
        delete: "Excluir",
        details: "Detalhes",
        groupDetails: "Detalhes do Grupo",
        title: "Título",
        description: "Descrição",
        modal: {
          title: "Criar grupo",
          name: "Nome do grupo",
          description: "Descrição do grupo",
          create: "Criar",
          cancel: "Cancelar",
          save: "Salvar",
          edit: "Editar",
        },
        modal: {
          title: "Criar Grupo",
          editTitle: "Editar Grupo",
          save: "Salvar",
          cancel: "Cancelar",
        },
      },
whitelabel: {
        primaryColorLight: "Cor Primária (Tema Claro)",
        primaryColorDark: "Cor Primária (Tema Escuro)",
        appName: "Nome da Aplicação",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Escuro)",
        favicon: "Favicon",
        backgroundLight: "Imagem de Fundo (Tema Claro)",
        backgroundDark: "Imagem de Fundo (Tema Escuro)",
        preview: "Visualizar",
        delete: "Excluir",
        upload: "Enviar",
        availableLanguages: "Idiomas Disponíveis",
        atLeastOneLanguage: "Pelo menos um idioma deve estar habilitado",

        sections: {
          general: "Configurações Gerais",
          generalDescription: "Configure o nome e informações básicas da aplicação",
          colors: "Cores e Temas",
          colorsDescription: "Personalize as cores primárias para temas claro e escuro",
          logos: "Logos e Imagens",
          logosDescription: "Carregue os logos e imagens de fundo da aplicação",
          languages: "Idiomas Disponíveis",
          languagesDescription: "Selecione quais idiomas estarão disponíveis no sistema"
        }
      },
    },
  },
};

export { messages };
